export default {
  getEmployeeDashboardCount: (state) => state.employeeCount,
};
